import { fetchData } from "../../helpers/api";

export async function fetchValproData(filters) {
  const { code, reportName, propType, queryParams, token } = filters;

  if (token) {
    queryParams.append("token", token);
  }

  return fetchData({
    endpoint: `widgets/:reportName/:propType/:code/valpro/`,
    params: { reportName, propType, code },
    queryParams,
    errorFlag: "WidgetError",
  });
}
